import {baseApi} from "@/utils/api.js";

const householdsApi = baseApi.enhanceEndpoints({
  addTagTypes: ['Households'],
}).injectEndpoints({
  endpoints: (builder) => ({
    getHouseholds: builder.query({
      query: () => ({
        url: '/households/',
        method: 'GET',
      }),
      providesTags: ['Households'],
    }),
    getHousehold: builder.query({
      query: ({ householdId }) => ({
        url: `/households/${householdId}`,
        method: 'GET',
      }),
      providesTags: ['Households'],
    }),
    createHousehold: builder.mutation({
      query: ({ data }) => ({
        url: '/households/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Households'],
    }),
    updateHousehold: builder.mutation({
      query: ({ id, data }) => ({
        url: `/households/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Households'],
    }),
  }),
});

export const {
  useGetHouseholdsQuery,
  useCreateHouseholdMutation,
  useUpdateHouseholdMutation,
  useGetHouseholdQuery,
} = householdsApi;
